import { Injectable, Inject } from '@angular/core';
import { DataService } from '../../../core/service/base/data.service';
import { Post } from '../../model/post';
import { HttpClient } from '@angular/common/http';
import { IAppConfig, APP_CONFIG } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';

@Injectable()
export class PostService extends DataService<Post> {
  constructor(
    client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    protected notification: MessageService,
    progressBar: ProgressBarService
  ) {
    super(client, config, notification, Post, progressBar, 'post');
  }
}
